import { IAsset } from "@/v1/components/pages/GameDetail/components/AssetsTab/types/Asset.interface";
import { AssetStatus } from "@/v1/components/pages/GameDetail/components/AssetsTab/utils/constants";

import { StateType } from "../useRequestsStore";

export const getAssetsByStatus = (status: AssetStatus, { get }: StateType) => {
  const queue = get().queue;
  return queue.filter(asset => asset.status === status) as IAsset[];
};
